import videoBannerAdClip from 'shared/videos/video_banner_ad.m4v'

// Not a real video: the ad stack needs a clip to hang a pre-roll on, so only the length matters.
export const AD_BANNER_CLIP = {
  id: 0,
  ad_position: 0,
  duration: '00:02',
  poster_url: '',
  show_ads: true,
  stream_urls: [videoBannerAdClip],
  title: 'Werbebanner',
}
